import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';


const marks = [
    {
        value: 0,
    },
    {
        value: 1,
    },
    {
        value: 2,
    },
    {
        value: 3,
    },
];

export default function Slider4PosComponent() {
    return (
        <Box sx={{ width: 140 }}>
            <Slider
                track={false}
                aria-labelledby="track-false-slider"
                defaultValue={3}
                marks={marks}
                max={3}
                min={0}
                disabled
                sx={{
                    '& .MuiSlider-rail': {
                        backgroundColor: 'blue',
                    },
                    '& .MuiSlider-thumb': {
                        backgroundColor: '#999'
                    },
                }}
            />
        </Box>
    );
}
